import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-reset-dialog',
  templateUrl: './confirm-reset-dialog.component.html',
  styleUrls: ['./confirm-reset-dialog.component.scss']
})
export class ConfirmResetDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmResetDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }


  DialogClose(){
    this.dialogRef.close(false)
  }
  submitFilePreview()
  {
    this.dialogRef.close(true)

  }
}
